import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { MonthNumber } from '../../../core/model/const/enums';
import { catchError } from 'rxjs/operators';
import { IndexClause } from '../../model/lease-row';
import { Money } from '../../../core/model/money';
import { IndexClauseSettings } from '../../model/index-clause-settings';

@Injectable()
export class IndexValueService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/index-value`;
  }

  private readonly _endpoint: string;

  getIndexValue(year: number, indexMonth: MonthNumber, indexClause: IndexClause): Observable<string> {
    return this._client.get(this._endpoint + '/getIndexValue/', {
      params: { year: year.toString(), indexMonth: indexMonth.toString(), indexClause: indexClause.toString() },
      responseType: 'text',
    });
  }

  getNewIndexRent(
    baseRent: Money,
    baseYear: number,
    baseIndexMonth: MonthNumber,
    currentYear: number,
    currentIndexMonth: MonthNumber,
    indexShare: number,
    indexClause: IndexClause,
    indexMinYearlyPercent: number,
    indexMaxYearlyPercent: number,
    indexClauseSettingsId: string | null
  ): Observable<Money> {
    const params: { [param: string]: string } = {
      baseRent: baseRent.amount.toString(),
      baseYear: baseYear.toString(),
      baseIndexMonth: baseIndexMonth.toString(),
      currentYear: currentYear.toString(),
      currentIndexMonth: currentIndexMonth.toString(),
      indexShare: indexShare.toString(),
      indexClause: indexClause.toString(),
      indexMinYearlyPercent: indexMinYearlyPercent ? indexMinYearlyPercent.toString() : '-100',
      indexMaxYearlyPercent: indexMaxYearlyPercent ? indexMaxYearlyPercent.toString() : '0',
      currencyCode: baseRent.currencyCode,
    };

    if (indexClauseSettingsId) {
      params.indexClauseSettingsId = indexClauseSettingsId;
    }

    return this._client.get<Money>(this._endpoint + '/calcIndexRent/', {
      params,
    });
  }

  getAllIndexClauses(): Observable<IndexClauseSettings[]> {
    return this._client.get<IndexClauseSettings[]>(this._endpoint + '/getCustomIndexClauses');
  }

  getCurrentPeriodRent(
    yearRent: Money,
    fromDate: string,
    toDate: string,
    calcPeriodFrom: string,
    calcPeriodTo: string,
    chargedMonths: MonthNumber[]
  ): Observable<any> {
    return this._client.post<any>(
      `${this._endpoint}/rentCurrentPeriod`,
      JSON.stringify({
        yearRent: yearRent,
        rentRowFrom: fromDate,
        rentRowTo: toDate,
        calcPeriodFrom: calcPeriodFrom,
        calcPeriodTo: calcPeriodTo,
        chargedMonths: chargedMonths,
      }),
      { headers: { 'Content-Type': 'application/json' } }
    );
  }
}
